<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Betaalde rente in/over andere jaren
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Heb je in {{ this.year }} een deel van de (hypotheek)rente vooruitbetaald voor een periode tot uiterlijk
                1 juli {{ this.year + 1 }}? En ben je dit contractueel overeengekomen? Dan is dit bedrag helemaal
                aftrekbaar in {{ this.year }}. Je mag dus maximaal een half jaar rente vooruitbetalen. Als je
                in {{ this.year }} vrijwillig een bedrag over {{ this.year + 1 }} hebt betaald, dan is dit bedrag pas
                in {{ this.year + 1 }} aftrekbaar. De vooruitbetaling moet je dan als box-3-bezitting op 1
                januari {{ this.year + 1 }} aangeven.
                <div class="space10"></div>

                Heb je in {{ this.year }} een deel van de (hypotheek)rente vooruitbetaald voor een periode na 30
                juni {{ this.year + 1 }}? Dan is het deel dat betrekking heeft op {{ this.year + 1 }} niet aftrekbaar
                in {{ this.year }}. Je mag in dat geval dus alleen de (hypotheek)rente aftrekken die je
                in {{ this.year }} hebt betaald over de periode 1 januari {{ this.year }} tot en met (uiterlijk) 31
                december {{ this.year }}. Het deel dat je niet mag aftrekken in {{ this.year }} trek je in gelijke delen
                af over de resterende jaren waarover je de rente betaalde.
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2"
                    aria-expanded="false" aria-controls="collapse2">
                Vooruit- en achteraf betaalde rente en kosten en geen of kleine eigenwoningschuld
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Heb je de rente en kosten voor de eigen woning voor een bepaald jaar contractueel vooruitbetaald of
                achteraf betaald? Dan betaal je in een ander jaar mogelijk minder rente dan het eigenwoningforfait. Je
                hebt dan toch geen recht op de aftrek vanwege geen of kleine eigenwoningschuld. Je moet de rente en
                kosten voor de berekening van de aftrek namelijk toerekenen aan het jaar waarover je de rente betaalde.
                <div class="space10"></div>
                Het programma houdt bij de berekening van de aftrek geen of geringe eigenwoningschuld rekening met de
                vooruit- en achter afbetaalde rente.

            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3"
                    aria-expanded="false" aria-controls="collapse3">
                Belast deel ontvangen uitkering kapitaalverzekering eigen woning
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Krijgt je een uitkering uit een kapitaalverzekering eigen woning? En gebruikt je die uitkering om je
                eigenwoningschuld (de hypotheek of lening voor je huis) af te lossen? Dan heb je meestal recht op een
                vrijstelling. Je hoeft dan geen belasting te betalen over de uitkering.
                <div class="space10"></div>

                Is de uitkering hoger dan de vrijstelling waar je recht op hebt? Dan moet je belasting betalen over de
                opgebouwde rente in het bedrag dat boven de vrijstelling uitkomt. De opgebouwde rente is de uitkering
                min de betaalde premies. Als je een fiscale partner hebt, moet je het belastbare deel van de uitkering
                van
                jezelf en van je fiscale partner aangeven.
                <div class="space10"></div>

                Het belastbare deel van de uitkering hoort bij de inkomsten uit de eigen woning. Je betaalt alleen
                belasting over de opgebouwde rente in het bedrag dat boven de vrijstelling uitkomt.
            </div>
        </div>
    </div>


</div>
